export default function gtag() {
    const key = import.meta.env.VITE_GTAG_ID;
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${key}`;
    script.async = true; 
    
    return script;
}